// @ts-check
import { graphql } from 'gatsby';
import React from 'react';
import { useContentStackProps } from '~/contentstack';
import BynderSimpleImage from '../components/BynderSimpleImage';
import LinkButton from '../components/LinkButton';

import './ImageButtonSection.scss';

export const ImageButtonSection_REFERENCES = ['image_button.image'];

export const query = graphql`
	fragment ImageButtonFragment on Ozk_content_blockModular_blocksCopyContent {
		image_button {
			display_button_label
			button_label
			button_link
			open_in_new_tab
			image {
				remoteToLocalImage {
					childImageSharp {
						imageButtonSection: gatsbyImageData(quality: 90, placeholder: BLURRED, layout: CONSTRAINED)
					}
				}
				...BynderImageFragment
			}
		}
	}
`;

/**
 * @typedef ImageButtonSectionOptions
 * @property {string} button_label
 * @property {string} button_link
 * @property {boolean} open_in_new_tab
 * @property {boolean} [display_button_label=false]
 * @property {import('../CSTypes').BynderImageOptions[]} image
 *
 * @typedef ImageButtonSectionProps
 * @property {import('~/contentstack/types').ModelWithLivePreviewAttr<ImageButtonSectionOptions>} [options]
 */
/** @type {React.FC<ImageButtonSectionProps>} */
const ImageButtonSection = ({ options }) => {
	const [currentProps] = useContentStackProps({
		staticModel: options.image?.[0],
		contentType: 'bynder_image',
		contentUid: options.image?.[0]?.uid,
	});

	return (
		<div>
			<LinkButton
				className="image-button-section"
				includeStyleClass={false}
				options={{ button_link: options.button_link, open_in_new_tab: options.open_in_new_tab }}
				{...options.$?.button_link}
			>
				<BynderSimpleImage option={currentProps} type="img" />
				{options.display_button_label && options.button_label && (
					<span {...options.$?.button_label}>{options.button_label}</span>
				)}
			</LinkButton>
		</div>
	);
};

export default ImageButtonSection;
